import type { DocPoint } from './features'

const META_ORDER = [
  'gpstime',
  'street',
  'section',
  'idtrack',
  'rawcourse',
  'image_quality',
  'street_segment_id',
  'image_path',
]

const MONO_KEYS = new Set(['gpstime', 'image_path', 'img_path', 'street_segment_id', 'idtrack'])

const NUMBER_FORMATS: Partial<Record<string, (value: number) => string>> = {
  image_quality: value => value.toFixed(3),
  rawcourse: value => `${value.toFixed(1)}°`,
}

export type MetadataRow = { key: string; value: string; mono: boolean }

export const formatMetadataValue = (key: string, value: unknown): string => {
  if (value == null) return '-'
  const format = NUMBER_FORMATS[key]
  const number = Number(value)
  return format && Number.isFinite(number) ? format(number) : String(value)
}

export const metadataRows = (point: DocPoint | null, positionLabel: string): MetadataRow[] => {
  if (!point) return []
  const props = point.props()
  const keys = new Set([...META_ORDER.filter(key => key in props), ...Object.keys(props)])
  return [
    ...[...keys].map(key => ({ key, value: formatMetadataValue(key, props[key]), mono: MONO_KEYS.has(key) })),
    { key: positionLabel, value: `${point.lat.toFixed(6)}, ${point.lon.toFixed(6)}`, mono: true },
  ]
}
